import { Box, Typography } from "@mui/material";
import data from "src/data/data.json";
import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";

interface DownloadExcelProps {
  onDownloadPressed?: () => void;
  file: string;
}

export const DownloadExcel: React.FC<DownloadExcelProps> = (props) => {
  const language = useSelector(selectCurrentLanguage);

  return (
    <Box
      bgcolor={"#E8E8E9"}
      padding={"10px 20px"}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      alignContent={"end"}
      justifyContent={"end"}
    >
      <Typography fontSize={"18px"} color={"#656665"}>
        {data[language].Analytics.DownloadExcel}
      </Typography>
      <Box width={"32px"} />
      <a
        download={"file.xlsx"}
        style={{
          backgroundColor: "#39d29f",
          color: "white",
          padding: "10px",
          borderRadius: "10px",
          fontWeight: "600",
        }}
        href={`data:application/xlsx;base64,${props.file}`}
      >
        {data[language].Analytics.DownloadExcelButton}
      </a>
    </Box>
  );
};